import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCommonState } from '@ports/common/commonStateSlice';
import { routePaths } from '@utils/constants/routePaths';
import MediaPostScreen from './MediaPostScreen';

const MediaPostWrapper: React.FC = () => {
  const { assetId } = useParams<{ assetId: string }>();
  const { selectedMedia } = useSelector(getCommonState);

  // Validate that we have the required data
  if (!assetId) {
    return <Navigate to={routePaths.Photos} replace />;
  }

  if (!selectedMedia) {
    return <Navigate to={routePaths.Photos} replace />;
  }

  if (selectedMedia.assetId !== assetId) {
    return <Navigate to={routePaths.Photos} replace />;
  }

  return <MediaPostScreen assetId={selectedMedia.assetId} />;
};

export default MediaPostWrapper;
